import classNames from 'classnames'
import { useEffect, useRef, useState } from 'react'

export const Timer = ({
  countNumber = 30,
  onComplete = () => {},
  className = 'text-base leading-[19.07px]'
}) => {
  const [count, setCount] = useState(countNumber)
  const interval = useRef()

  useEffect(() => {
    if (count == 0) {
      clearInterval(interval?.current)
      onComplete()
    }
  }, [count])

  const decreaseCount = () => {
    setCount((prv) => prv - 1)
  }

  useEffect(() => {
    interval.current = setInterval(decreaseCount, 1000)
    return () => clearInterval(interval?.current)
  }, [])

  return (
    <div className={classNames('font-noto-sans  font-bold ', className)}>
      00:{count >= 10 ? count : `0${count}`}
    </div>
  )
}
